import React from 'react';
import PropTypes from 'prop-types';

import { Section } from '../..';
import { checkSectionCondition } from '../../../Form.helpers';

const WorkExperience = ({ field, translations }) => {
    const { totalWorkExperienceName, currentWorkPositionLevelName } = field;

    const fieldArray = [totalWorkExperienceName, currentWorkPositionLevelName];
    const renderedSection = checkSectionCondition(fieldArray);

    return (
        <Section.Conditional
            condition={Boolean(field.order) && renderedSection}
            title={translations.workExperience}
        >
            {({ renderField }) => (
                <>
                    {renderField(translations.positionLevel, field.currentWorkPositionLevelName)}
                    {renderField(translations.totalExperienceDuration, field.totalWorkExperienceName)}
                </>
            )}
        </Section.Conditional>
    );
};

WorkExperience.propTypes = {
    field: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired
};

export default WorkExperience;